import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { TextView } from "../../../components";
import Table from "../../../components/Table";
import { getAnalyticsDetail, search } from "../../../services/api";
import { colors } from "../../../utils";
import { CLONES_COLUMNS } from "../data/AnalyticsHelpers";
import SearchInput from "./SearchInput";
import CloneIcon from "assets/images/analytics/cloneIcon.svg";
import BackIcon from "assets/images/analytics/back.svg";
import FavoriteIcon from "assets/images/analytics/favoriteFilled.svg";
import ViewIcon from "assets/images/analytics/viewIcon.svg";
import UnlockIcon from "assets/images/analytics/unlockIcon.svg";

const Container = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
  min-height: 400px;
  width: 50vw;
  min-width: 550px;
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 40px;
`;

const Divider = styled.div`
  border: 1px solid #E1E1E1;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

const Heading = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const IconContainer = styled.div`
  display: flex;
  border-radius: 4px;
  gap: 10px;
  background-color: #F6F7F9;
  padding: 8px;
`;

const Content = styled.div`
  overflow-y: auto;
`;

export default function TablesModal({
  open,
  onClose,
  analyticData,
  wheelId,
  category,
}) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchParam, setSearchParam] = useState("");

  const categoryConfig = {
    0: { icon: CloneIcon, title: "Cloned by" },
    1: { icon: FavoriteIcon, title: "Favorited by" },
    2: { icon: ViewIcon, title: "Viewed by" },
    3: { icon: UnlockIcon, title: "Unlocked by" },
  };

  useEffect(() => {
    fetchData();
  }, [offset, searchParam]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getAnalyticsDetail({
        offset,
        category: category,
        wheel_id: wheelId,
        search: searchParam,
      });
      setLoading(false);
      setData(response?.data?.results);
      setTotalRecords(response?.data?.count);
      setCurrentPage((Number(offset) + 10) / 10);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const onPaginationClicked = (offset) => {
    setOffset(offset);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    if (e.target.value == "") {
      setSearchParam("");
    }
  };

  const handleCancel = () => {
    setSearchText("");
    setSearchParam("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearchParam(searchText);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Container>
        <StyledIcon src={BackIcon} alt="back" onClick={onClose} />
        <Divider />
        <Row>
          <Heading>
          <IconContainer>
            <img src={categoryConfig[category].icon} 
              alt={`${categoryConfig[category].title} icon`} 
              style={{ width: '24px', height: '24px' }}
            />
          </IconContainer>
          <TextView variant="largeTitle">
            {categoryConfig[category].title}
          </TextView>
          </Heading>
          <SearchInput
            value={searchText}
            handleChange={handleSearch}
            handleKeyPress={handleKeyPress}
            handleCancel={handleCancel}
            moveIcon={true}
          />
        </Row>
        <Content>
          <Table
            paginationTotalRows={totalRecords}
            progressPending={loading}
            data={data}
            columns={CLONES_COLUMNS}
            onPaginationClicked={onPaginationClicked}
            currentPage={currentPage}
          />
        </Content>
      </Container>
    </Modal>
  );
}
